import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class CentralBlankTabMessage extends React.Component {
  render () {
    const classes = {
      "central-blank-tab-message": true,
      "pull-message-up": !this.props.doNotPullMessageUp,
      "show-background": this.props.showBackground
    };

    const styles = this.props.styles || {};

    return (
      <div style={styles} className={classNames(classes)}>
        <div>
          {this.props.message}
          {this.props.children}
        </div>
      </div>
    );
  }
}

CentralBlankTabMessage.propTypes = {
  message: PropTypes.string,
  doNotPullMessageUp: PropTypes.bool,
  showBackground: PropTypes.bool,
  styles: PropTypes.object,
  children: PropTypes.node
};

export default CentralBlankTabMessage;
